// @ts-nocheck
import { AbstractRequestStatusMessage } from "./AbstractRequestStatusMessage";

export class RequestStatusMessage extends AbstractRequestStatusMessage {
  constructor() {
    super();
  }
}
